import { Theme } from "apps/website/maps/Theme.map";
import { Justify } from "apps/website/maps/Flex.map";

import { TDirection, TSize } from "../SectionArrow.map";

export type BorderTheme = Exclude<
  Theme,
"dark-alt" | "brand-alt" | "header" | "form-input" | "footer" | "product-card"
>;

export interface ISectionArrowProps {
  direction?: TDirection;
  backgroundTheme?: Theme;
  arrowTheme?: BorderTheme;
  size?: TSize;
  justify?: Justify;
  className?: string;
}

export const borderClassByTheme: Record<BorderTheme, string> = {
  default: "border-b-default",
  dark: "border-b-dark", /* doesn't exist */
  light: "border-b-light", /* doesn't exist */
  color: "border-b-color", /* doesn't exist */
  brand: "border-b-brand",
  "chartreuse-100": "border-b-chartreuse-100",
  "light-grey": "border-b-light-grey",
  "light-grey-75": "border-b-light-grey-75",
  "cool-grey-40": "border-b-cool-grey-40",
  "sand-200": "border-b-sand-200",
  "mid-green": "border-b-mid-green",
  "green-light": "border-b-green-light",
  "grey-400": "border-b-grey-400",
  "grey-500": "border-b-grey-500",
  blue: "border-b-blue",
  "light-blue": "border-b-light-blue",
  "mid-blue": "border-b-mid-blue",
  red: "border-b-red",
  pink: "border-b-pink",
  orange: "border-b-orange",
  green: "border-b-green",
  inherit: "border-b-inherit",
};
